import { BASE, axiom } from "../../utils";

export const getBids = async ({ shopId, productId }) => {
  const resp = await (
    await fetch(BASE + "/auction/byProduct/" + shopId + "/" + productId, {
      method: "GET",
    })
  ).json();

  switch (resp.kind) {
    case "Ascending": {
      return resp.ascending_state.bids;
    }
  }
  return [];
};

export const placeBid = async ({
  abortController,
  auctionId,
  productId,
  customerId: customer_id,
  action,
  params,
}) => {
  const sendDate = new Date().getTime();

  try {
    const result = await (
      await fetch(BASE + "/bid", {
        signal: abortController.signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          auction_id: auctionId,
          product_id: productId,
          customer_id,
          action: {
            [action]: {
              ...params,
            },
          },
        }),
      })
    ).json();

    await axiom(abortController, {
      action: "placeBid",
      responseLength: JSON.stringify(result).length,
      responseTime: new Date().getTime() - sendDate,
      error: null,
    });

    return result.invoice_url ? result.invoice_url : "";
  } catch (error) {
    await axiom(abortController, {
      action: "placeBid",
      responseLength: -1,
      responseTime: new Date().getTime() - sendDate,
      error,
    });
  }
  return null;
};
